import * as _ from "lodash"

export const FORCE_UNDEFINED: any = undefined

export function isUnique(x: Iterable<any>): boolean {
    return (new Set(x)).size == _.size(x)
}